import * as React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { equabotzSettingsPath, Organization, User } from '@logic'
import { PageContent } from '@components/pages'
import { PageContentHeader } from '@components/pages/page-content-header'
import { StateTransform } from '@src/index'
import { buildEquabotzSettingsSearch } from '@modules/equabot-settings/services/scope-query'

interface StateProps {
  currentOrganization?: Organization
  user?: User
}

function settingsRedirect(orgId?: string) {
  return {
    pathname: equabotzSettingsPath,
    search: buildEquabotzSettingsSearch(window.location.search, orgId),
    hash: window.location.hash,
  }
}

const OrganizationEquabotzPageComponent: React.FC<StateProps> = ({ currentOrganization, user }) => {
  // No current org yet — fall back to the canonical account settings surface.
  if (!currentOrganization) {
    return <Redirect to={settingsRedirect()} />
  }

  // Only admins of the organization can configure its Equabot settings.
  // `creator === user.id` is the canonical admin-of-org check in this repo
  // (see equabot-settings-page.tsx and equabotz-page.tsx buildScopes).
  const isOrgAdmin = !!user && currentOrganization.creator === user.id

  if (!isOrgAdmin) {
    return (
      <PageContent>
        <PageContentHeader title="Equabotz" />
        <p style={{ padding: 24 }}>
          Organization Equabot configuration requires admin permission. You are a member of{' '}
          <strong>{currentOrganization.name || 'this organization'}</strong>, but only the organization
          admin can view or change its Equabot settings. Visit{' '}
          <a href={equabotzSettingsPath}>{equabotzSettingsPath}</a> to configure your personal account.
        </p>
      </PageContent>
    )
  }

  return (
    <Redirect
      to={settingsRedirect(currentOrganization.id)}
    />
  )
}

const mapStateToProps: StateTransform<StateProps> = s => ({
  currentOrganization: s.organization?.currentOrganization,
  user: s.user,
})

export const OrganizationEquabotzPage = connect(mapStateToProps)(OrganizationEquabotzPageComponent as any)
